<template>
<!--  <div class="container">-->
<!--      <img src="../assets/images/tips.png" style="width: 100%">-->
<!--  </div>-->
  <div class="container" :style="{backgroundImage:'url('+require('@/assets/images/main-bg.png')+')'}">
    <div class="header">
      <img :src="require('@/assets/images/header.png')" alt="header" />
    </div>
    <div class="box-desc">
      <img :src="require('@/assets/images/box-bg-desc.png')" alt="大赛概述" />
    </div>
    <div class="box-top">
      <img :src="require('@/assets/images/box-bg1.png')" alt="box" />
    </div>
    <div class="info-box" v-if="isActivityStarted" :style="{backgroundImage:'url('+require('@/assets/images/box-bg.png')+')'}">
        <img class="info-btn" @click="$router.push('/explain')" :src="require('@/assets/images/icon2.png')" alt="">
        <div class="info-content">
        <div class="info-text">
          <p class="info-title">投票规则</p>
          <p>每个手机号每天可以投票<span class="count">10</span>次</p>
          <p>每个作品每天只能投票<span class="count">1</span>次</p>
          <p class="vote-time"><img :src="require('@/assets/images/clock.png')" alt="clock" /> <span>投票时间：{{vote_date}}</span></p>
        </div>
      </div>
    </div>
    <div class="main-box" v-if="isActivityStarted">
      <img class="main-box-top" :src="require('@/assets/images/box-bg-top.png')" alt="">
      <div class="main-box-tabs">
        <div class="tab-item" :class="{active: tab === 1}" @click="switchTabs(1)">全部作品</div>
        <div class="tab-item" :class="{active: tab === 2}" @click="switchTabs(2)">票数排行</div>
      </div>
      <div class="main-box-middle">
      <div class="content">
        <div class="search">
          <img class="search-icon" :src="require('@/assets/images/search-button.png')" alt="">
          <input type="text" v-model="keyword" class="search-input" placeholder="输入序号搜索作品">
        </div>
        <div class="lists">
          <van-list
            v-model="loading"
            :finished="finished"
            finished-text="没有更多了"
            @load="onLoad"
          >
            <div class="item-box" v-for="(item, index) in list" :key="index">
              <div class="item-outer">
                <div class="item" @click="$router.push('/content/'+item.id)">
                  <div class="title">{{ item.title }}</div>
                  <div class="number">票数：<span>{{ item.votenum }}票</span></div>
                  <div class="item-divider"></div>
                  <div class="item-image-wrap">
                    <img class="item-images" :src="item.zuopin=='' ? require('@/assets/images/default_picture.png') : item.zuopin" alt="">
                    <span class="item-number-text">{{ item.id }}</span>
                  </div>
                </div>
                <img class="vote-btn" :src="require('@/assets/images/vote.png')" alt="" @click.stop="changeVote(item.id)">
              </div>
            </div>
            <div class="clear"></div>
          </van-list>
        </div>
      </div>
      </div>
      <img class="main-box-bottom" :src="require('@/assets/images/box-bg-bottom.png')" alt="">
      <div class="line"></div>
    </div>

    <van-overlay :show="captcha" @click="captcha=false">
      <div id="embed-captcha"></div>
    </van-overlay>

    <div class="qrcode-box">
      <img :src="require('@/assets/images/ewm1.png')" alt="二维码1" />
      <img :src="require('@/assets/images/ewm2.png')" alt="二维码2" />
      <img :src="require('@/assets/images/ewm3.png')" alt="二维码3" />
    </div>
  </div>
</template>

<script>
import { Toast } from 'vant';
import $ from 'jquery'
import "@/assets/js/gt"
// 引入微信
import wx from "weixin-js-sdk";

export default {
  name: 'Home',
  data () {
    return {
      id: 0,
      tab: 1,
      list: [],
      page: 1,
      page_size: 10,
      loading: false,
      finished: false,
      sort: '',
      voteing: false,
      captcha: false,
      time: '',
      keyword: '',
      vote_date:'2025年2月10日至2月19日',
      starDate:'',
      endDate:'',
      showActivity: false,
    }
  },
  computed: {
    isActivityStarted() {
      return this.showActivity;
    }
  },
  mounted() {
    var that = this
    // 从服务端获取投票时间配置
    that.$api.get('/default/voteTime').then(function (res) {
      if (res.data.code === 0 && res.data.data) {
        that.vote_date = res.data.data.vote_date || '';
        that.starDate = res.data.data.vote_start_date || '';
        that.endDate = res.data.data.vote_end_date || '';
      }
      var date = new Date(that.endDate || '');
      var date1 = new Date();
      that.time = date.getTime() - date1.getTime();

      let ua = navigator.userAgent.toLowerCase();
      let isWeixin = ua.indexOf('micromessenger') != -1;
      if(isWeixin){
        that.wechatSign();
      }
    }).catch(function (error) {
      console.log(error);
      // 即使请求失败，也尝试计算倒计时（若 endDate 有默认值）
      var date = new Date(that.endDate || '');
      var date1 = new Date();
      that.time = date.getTime() - date1.getTime();
      let ua = navigator.userAgent.toLowerCase();
      let isWeixin = ua.indexOf('micromessenger') != -1;
      if(isWeixin){
        that.wechatSign();
      }
    });
  },
  methods: {
    changeVote(id) {
      if (this.isVotingTime()) {
          this.id = id;
          this.captcha = true;
          this.initGT()
      }

    },
    //判断是否在投票的时间段
    isVotingTime(){
      const now = new Date();
      const startDate = new Date(this.starDate);
      const endDate = new Date(this.endDate);
      console.log(now)
        console.log(startDate)
        console.log(now < startDate)
      if (now < startDate) {
          console.log('未到投票时间');
          Toast.success('未到投票时间！');
          return false;

      }else if(now > endDate){
          console.log('投票已结束')
          Toast.success('投票已结束！');
          return false;
      } else {
          console.log('可以投票')
          return true;
      }

    },
    doSearch() {
      this.tab = 1;
      this.sort = '';
      this.list = [];
      this.page = 1;
      this.onLoad();
    },
    doVote(validate) {
      let that = this
      if(that.voteing){
        return false;
      }
      that.voteing = true;
      validate.id = that.id
      that.$api.post('/default/addVote', validate).then(function (response) {
        console.log(response)
        that.voteing = that.captcha = false;
        if (response.data.code === 0) {
          // 增加票数
          that.list.forEach(function(item, index){
            if(that.list[index].id==that.id){
              that.list[index].votenum++
            console.log(that.list[index].votenum)
            }
          })
          Toast.success('投票成功！');
        } else {
          Toast.fail(response.data.msg);
        }
        $("#embed-captcha").html('')
      }).catch(function (error) {
        that.voteing = false;
        Toast.fail(error);
      });
    },
    switchTabs(tab) {
      this.tab = tab;
      this.sort = tab==1 ? '' : 'votenum';
      if(tab==2){
        this.keyword = '';
      }
      this.list = [];
      this.page = 1;
      this.onLoad();
    },
    onLoad() {
      let that = this
      that.$api.get('/default/index', {
        params: {
          page: that.page,
          limit: that.page_size,
          sort: that.sort,
          id: that.keyword,
        }
      }).then(function (response) {
        console.log(response)
        // 加载状态结束
        that.loading = false;
        if(response.data.data.records.length < 10){
          that.finished = true;
        }
        that.page += 1;
        if(that.keyword==''){
          that.list = that.list.concat(response.data.data.records);
        }else{
          that.list = response.data.data.records;
        }
      }).catch(function (error) {
        console.log(error);
        Toast.fail(error);
      });
    },
    initGT(){
      $("#embed-captcha").html('')
      var that = this
      that.$api.get('/default/geetestReg?t='+(new Date()).getTime()).then(res=>{
        let data=res.data.data
        // data.new_captcha = 1
        // eslint-disable-next-line no-undef
        initGeetest({
          gt: data.gt,
          challenge: data.challenge,
          // new_captcha: 1, // 用于宕机时表示是新验证码的宕机
          offline: !data.success, // 表示用户后台检测极验服务器是否宕机，一般不需要关注
          product: "bind", // 产品形式，包括：float，popup
          // width: "100%"
        }, function (captchaObj) {
          // 将验证码加到id为captcha的元素里，同时会有三个input的值：geetest_challenge, geetest_validate, geetest_seccode
          captchaObj.appendTo("#embed-captcha");
          captchaObj.onReady(function(){
          }).onSuccess(function(){
            var validate = captchaObj.getValidate();
            that.doVote(validate)
          }).onError(function(){
            console.log(333)
          })
        });
      })
    },
    /*微信分享*/
    wechatSign() {
      let url = document.URL;
      if (url) {
        let that = this
        this.$api.get('/wechat/sign', {
          params: {
            url: url
          }
        }).then(function (res) {
          console.log(res)
          // 加载状态结束
          if (res.data.code === 0) {
            that.shareJs(res.data.data)
          } else {
            // alert(JSON.stringify(res));
            Toast.fail(res.data.msg);
          }
        }).catch(function (error) {
          console.log(error);
          Toast.fail(error);
        });
      }
    },
    /*微信分享*/
    shareJs(jssdk, options) {
      // alert(JSON.stringify(jssdk));
      wx.config({
        debug: false,//是否开启调试功能，这里关闭！
        appId: jssdk.appId,//appid
        timestamp: parseInt(jssdk.timestamp), //时间戳
        nonceStr: jssdk.nonceStr, //生成签名的随机字符串
        signature: jssdk.signature,//签名
        jsApiList: [
          "onMenuShareTimeline",
          "onMenuShareAppMessage",
          'updateTimelineShareData',
          'updateAppMessageShareData'
        ]
      });
      var defaults = {
        title: "第五届广西版权公益海报设计大赛",
        desc: "投票你最喜欢的海报～",
        link: location.href, //分享页面地址,不能为空，这里可以传递参数！！！！！！！
        imgUrl: 'https://www.gxbdhi.com.cn/logo.jpg', //分享是封面图片，不能为空
        success: function () { } //分享成功触发
      }
      // 合并对象，后面的替代前面的！
      options = Object.assign({}, defaults, options);
      console.log(options)
      wx.ready(function () {
        var thatopts = options;
        // 分享到朋友圈
        wx.updateTimelineShareData({
          title: thatopts.title, // 分享标题
          link: thatopts.link, // 分享链接
          imgUrl: thatopts.imgUrl, // 分享图标
          success: function () {
            // alert("成功");
          }
        });
        // 分享给朋友
        wx.updateAppMessageShareData({
          title: thatopts.title, // 分享标题
          desc: thatopts.desc, // 分享描述
          link: thatopts.link, // 分享链接
          imgUrl: thatopts.imgUrl, // 分享图标
          success: function () {
            // alert("成功");
          }
        });
        // 分享到朋友圈
        wx.onMenuShareTimeline({
          title: thatopts.title, // 分享标题
          link: thatopts.link, // 分享链接
          imgUrl: thatopts.imgUrl, // 分享图标
          success: function () {
            // alert("成功");
          }
        });
        // 分享给朋友
        wx.onMenuShareAppMessage({
          title: thatopts.title, // 分享标题
          desc: thatopts.desc, // 分享描述
          link: thatopts.link, // 分享链接
          imgUrl: thatopts.imgUrl, // 分享图标
          success: function () {
            // alert("成功");
          }
        });
      });
    }
  },
}
</script>

<style scoped>
  .header{width: 100%;display: block;}
  .container{background-size:100% 100%;background-repeat:no-repeat;}
  .header img{width:100%;display:block;height:auto;}
  .box-desc{margin:50px 10px 0 20px;background-size:100% 100%;background-repeat:no-repeat;position: relative;}
  .box-desc img{width:100%;display:block;height:auto;}
  .qrcode-box{display:flex;justify-content:center;align-items:center;padding:50px 10px 100px 10px;}
  .qrcode-box img{width:30%;margin:0 5px;}
  .box-top{margin:50px 10px 0 20px;background-size:100% 100%;background-repeat:no-repeat;position: relative;}
  .box-top-icon{position: absolute;top: -15px;left: -20px;width: 60px;z-index: 10;}
  .box-top img{width:100%;display:block;height:auto;}
  .box-top img.box-top-icon{width: 88%;}
  .info-box{margin:50px 10px 0 20px;background-size:100% 100%;background-repeat:no-repeat;padding:40px;position: relative;}
  .info-btn{position: absolute;top: -20px;left: 50%;transform: translateX(-50%);width: 240px;z-index: 10;}
  .info-content{display:flex;justify-content:space-between;align-items:flex-end;}
  .info-text{width:100%;padding:8px 0;color:#333;font-size:28px;}
  .info-text p{margin:6px 0; text-align: center;}
  .info-title{font-size:28px;font-weight:800;margin:6px 0 14px;}
  .count{color:#FF0000;font-size:36px;font-weight:900;margin:0 6px;}
  .vote-time{display:flex;align-items:center;justify-content:center;padding-top: 10px;color:#0a15fc;font-size: 30px;font-weight: 800;}
  .vote-time img{width:30px;height:30px;margin-right:8px;display:block;}
  .bg-top{height:0;padding-bottom: 149%;background-size: 100%;position: relative;}
  .box{padding: 40px 40px 20px;text-align: center;background-size: 100%;}
  .main-box{margin:40px 10px 0 20px;position: relative;}
  .main-box-top{width:100%;display:block;height:auto;}
  .main-box-tabs{position: absolute;top: -20px;left: 50%;transform: translateX(-50%);z-index: 10;display: flex;width: 80%;gap: 10px;height: 80px;align-items: center;}
  .tab-item{flex: 1;padding: 15px 10px;text-align: center;background: linear-gradient(to bottom, #7b94f8, #5f80f8);border-radius: 20px;font-size: 28px;color: #fff;display: flex;align-items: center;justify-content: center;height: 60px;}
  .tab-item.active{background: linear-gradient(to bottom, #4a3bfe, #0a15fe);color: #fff;font-size: 32px;font-weight: bold;height: 75px;}
  .main-box-middle{background:url('~@/assets/images/box-bg-middle.png') repeat-y center top;background-size:100% auto;}
  .main-box-bottom{width:100%;display:block;height:auto;}
  .qrcode{position:absolute;width:90%;top:5.4rem;left: 5%;}
  .explain{position:absolute;width: 40%;top: 10rem;left: 30%;}
  .time{width:80%;height:80px;line-height:80px;margin: 0 10% 0.3rem;font-size:26px;background-size: 100% 100%;text-align: center;}
  .time p{color:#4F4E4D;margin:0;font-weight: 600;}
  .time p .van-count-down{color:#E16002;display:inline-block;}
  .content{clear:both;padding-top:70px;}
  /*background-color: rgb(195,227,255);*/
  .search{margin:0 60px 0 40px;position: relative; height:70px;border-radius: 35px; background: #dcdcdc;display: flex;align-items: center;padding: 0 20px;}
  .search .search-icon{width:36px;height:36px;margin-right: 15px;}
  .search-input{flex: 1;background:none;height:100%;border:none;font-size:28px;color:#999;outline: none;}
  .lists{padding:20px 36px 20px 20px;min-height:520px;}
  .lists .item-box{width:50%;float:left;margin-bottom:35px;padding: 0 10px;box-sizing: border-box;}
  .lists .item-outer{cursor: pointer;}
  .lists .item{background: #fff;border-radius: 12px;box-shadow: 0 4px 20px rgba(0,0,0,0.1);overflow: hidden;padding: 15px 12px;}
  .lists .item .title{font-size:26px;color:#333;font-weight: 600;display: -webkit-box;-webkit-box-orient: vertical;-webkit-line-clamp: 2;overflow: hidden;line-height: 1.4;min-height: 73px;}
  .lists .item .number{font-size:24px;color:#666;margin-top: 10px;}
  .lists .item .number span{color:#d93609;font-weight: 600;}
  .lists .item .item-divider{height: 1px;background: #e5e5e5;margin: 15px 0;}
  .lists .item .item-image-wrap{position: relative;width:100%;padding-bottom: 120%;}
  .lists .item .item-images{position: absolute;top: 0;left: 0;width:100%;height:100%;object-fit: cover;border-radius: 8px;}
  .lists .item .item-number-text{position: absolute;top:0;right:0;background: #d93609;color:#fff;font-size:22px;font-weight: bold;padding: 8px 15px;border-radius: 0 8px 0 8px;}
  .lists .vote-btn{width:80%;margin:15px auto 0;display:block;}
  .clear{clear:both;}
  .line{height:20px;width:100%;}
  .van-overlay{z-index:99;}
  .van-loading{left:50%;top:50%;}
  #embed-captcha{left:100px;top:40%;position: absolute}
</style>
